<template>
  <el-form ref="form" :model="form" class="form-insert">
    <h4>{{L10n('create-po')}}</h4>
    <div class="row">
      <div class="col-xl-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('po')"
          prop="po"
          class="material-style"
          :rules="rulesPo"
        >
          <el-input
            :value="form.po"
            @input="form.po = valueTrimLeft($event)"
            @change="updateViewData('po', { 'po': $event })"
          />
        </el-form-item>
      </div>
      <div class="col-xl-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('po-date')"
          :rules="getValidationRule('required')"
          prop="poDate"
          class="material-style"
        >
          <date-picker
            v-model="form.poDate"
            @change="updateViewData('poDate', { 'poDate': $event })"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-xl-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('requested-date')"
          prop="requestedDate"
          class="material-style"
        >
          <date-picker
            v-model="form.requestedDate"
            @change="updateViewData('requestedDate', { 'requestedDate': $event })"
          ></date-picker>
        </el-form-item>
      </div>
      <div class="col-xl-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('order-rating-score')"
          prop="scoreID"
          class="material-style"
        >
          <select-response
            :model.sync="form.orderRatingScoreID"
            @on-data-value="(data) => updateViewData('orderRatingScoreText', data, 'scoreText')"
            :fields="{ id: 'id', title: 'scoreText' }"
            :data="dataSourceScore.records"
            :isLoading="dataSourceScore.loading"
          ></select-response>
        </el-form-item>
      </div>
      <div class="col-xl-4 col-md-6 col-12">
        <el-form-item
          :label="L10n('payment-term')"
          prop="paymentTermID"
          class="material-style">
          <select-response
            :model.sync="form.paymentTermID"
            @on-data-value="(data) => updateViewData('paymentTermTitle', data, 'title')"
            :isLoading="dataSourcePaymentTerm.loading"
            :data="dataSourcePaymentTerm.records"
          ></select-response>
        </el-form-item>
      </div>
    </div>
    <div class="row">
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('ship')"
          prop="shipToCompanyID"
          class="material-style"
        >
          <select-company
            :model.sync="form.shipToCompanyID"
            @on-data-value="(data) => updateViewData('shipToCompanyName', data, 'name')"
            @on-created="mixCreateShipTo"
            @on-change="(id) => mixChangeShipToID(id)"
          >
          </select-company>
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('ship-detail')"
          prop="shipToCompanyDetailID"
          class="material-style">
          <select-company-detail
            :model.sync="form.shipToCompanyDetailID"
            :companyID="form.shipToCompanyID"
            @on-data-value="(data) => updateViewData('shipToCompanyDetailCountry', data, 'country')"
          ></select-company-detail>
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('ship-contact')"
          prop="shipToCompanyContactID"
          class="material-style">
          <select-company-contact
            :model.sync="form.shipToContactID"
            :companyID="form.shipToCompanyID"
            @on-data-value="updateViewDataShipToContact"
          ></select-company-contact>
        </el-form-item>
      </div>
      <div class="col-md-3 col-12">
        <el-form-item
          :label="L10n('customer-forwarder')"
          prop="customerForwarderID"
          class="material-style"
        >
          <select-forwarder
            :companyID="customerID"
            :model.sync="form.customerForwarderID"
            @on-data-value="updateViewDataForwarder"
          ></select-forwarder>
        </el-form-item>
      </div>
    </div>
    <button-line @click="handlerCreate">
      {{L10n('create-po')}}
    </button-line>
  </el-form>
</template>

<script>
import { mixUpdateShipTo } from '@/mixins/companies.js'

export default {
  name: 'RFQPoForm',
  mixins: [mixUpdateShipTo],
  components: {
    'select-forwarder': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectForwarder/Index.vue'),
    'select-company': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompany/Index.vue'),
    'select-company-contact': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyContact/Index.vue'),
    'select-company-detail': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/SelectCompanyDetail/Index.vue'),
    'button-line': () => import(/* webpackChunkName: 'UI' */ '@/components/UI/ButtonLine.vue')
  },
  props: {
    customerID: { required: true },
    checkValidSupplier: { type: Function },
    data: { type: Object, required: true },
    supplierCompanyID: { required: true },
    supplierCompanyName: { type: String },
    title: { type: String }
  },
  data () {
    return {
      form: {},
      defaultPo: this.$moment().format('YYMMDD') + 'x.'
    }
  },
  mounted () {
    this.form = this.formModel()
    this.$emit('command', 'mounted', {
      ...this.form,
      supplierCompanyID: this.supplierCompanyID,
      supplierCompanyName: this.supplierCompanyName
    })
  },
  computed: {
    dataSourceScore () {
      return this.API('Scores/GetAllDynamic?select=id,scoreText')
    },
    dataSourcePaymentTerm () {
      return this.API('PaymentTerms/GetAllDynamic?select=id,title&orderBy=title')
    },
    rulesPo () {
      const mustChange = {
        validator: (rule, value, cb) => {
          if (value === this.defaultPo) {
            return cb(new Error(this.L10n('need-change-value')))
          }
          return cb()
        }
      }
      return [mustChange].concat(this.getValidationRule('required'))
    }
  },
  methods: {
    updateModelItem () {
    },
    updateViewDataShipToContact (data) {
      let title = [];
      ['name', 'email'].forEach((name) => {
        if (data && data[name]) {
          title.push(data[name])
        }
      })
      this.updateViewData('shipToContactName', { title: title.join(' - ') }, 'title')
    },
    updateViewDataForwarder (data) {
      let title = [];
      ['accountNumber', 'forwarderShipperName'].forEach((name) => {
        if (data && data[name]) {
          title.push(data[name])
        }
      })
      this.updateViewData('customerForwarderName', { title: title.join(' - ') }, 'title')
    },
    updateViewData (name, dataValue, field = name) {
      this.$emit('command', 'update-view', {
        [name]: (dataValue && dataValue[field]),
        supplierCompanyID: this.supplierCompanyID
      })
    },
    formModel () {
      return {
        po: this.defaultPo,
        baxpo: 'XXX' + this.$moment().format('YYMMDD') + 'x.',
        poDate: new Date(),
        requestedDate: new Date(),
        orderRatingScoreID: null,
        paymentTermID: null,
        shipToCompanyID: null,
        shipToCompanyDetailID: null,
        shipToContactID: null,
        customerForwarderID: null
      }
    },
    handlerCreate () {
      if (!this.checkValidSupplier(this.supplierCompanyID).length) {
        return this.$notify.error({
          title: 'Error',
          message: this.L10n('must-check-at-least-one-part'),
          position: 'bottom-right'
        })
      }
      this.$refs.form.validate()
        .then(() => {
          this.$emit('command', 'create', { ...this.form, supplierCompanyID: this.supplierCompanyID })
        })
    }
  }
}
</script>
